import { render } from "./BilGrosPrivacyPolicy.vue?vue&type=template&id=e150bac2&scoped=true"
const script = {}

import "./BilGrosPrivacyPolicy.vue?vue&type=style&index=0&id=e150bac2&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e150bac2"]])

export default __exports__